import React from 'react';
import PropTypes from 'prop-types';
import { RadioInput } from 'components/core/RadioInput';

import './Checkbox.scss';
import { withClickTracking } from 'components/core/library/tracking-utils';

function Checkbox({ error, ...rest }) {
	return (
		<RadioInput
			{...rest}
			className="ss-checkbox"
			type="checkbox"
		>
			{!!error && <div className="error-message">{error}</div>}
		</RadioInput>
	);
}

Checkbox.propTypes = {
	error: PropTypes.node,
};

export default withClickTracking(Checkbox);
